import {
  AngebotsId,
  GlobalAction,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { all, call, race, take } from 'redux-saga/effects';

function* handleFailure<T>(action: GlobalAction<T>, globalPut: GlobalPut): Generator {
  if (action.type === GlobalActions.TARIFIERUNG_TRIGGERED_BEIBEHALTUNG) {
    const payload = action.payload as unknown as AngebotsId;
    yield call(
      globalPut.put,
      new GlobalActions().produktDeleted([
        { appId: payload.appId, angebotsId: payload.angebotsId },
      ]),
    );
  } else {
    yield call(globalPut.put, new GlobalActions().restoreStateSnapshot());
    if (action.type === GlobalActions.PRODUKT_DELETED) {
      PS20Logger.info(
        'addTaasUpdateAppErrorHandling.updateFailedAfterDeletion',
        JSON.stringify({ trigger: action.type }),
        App.SHOP,
      );
      yield call(globalPut.put, new GlobalActions().tarifiereShopStale());
    }
  }
}

export const addTaasUpdateAppErrorHandling = <T>(
  updateAppActionsCreator: (actionPayload: T) => GlobalAction<unknown>[],
  successActionsCreator?: (actionPayload: T) => Array<string>,
  failActionsCreator?: (actionPayload: T) => Array<string>,
  afterShopSuccess?: () => Generator,
  afterShopError?: () => Generator,
) => {
  return function* (action: GlobalAction<T>) {
    const globalPut = GlobalPut.getInstance();
    for (const updateAppAction of updateAppActionsCreator(action.payload)) {
      yield call(globalPut.put, updateAppAction);
    }

    const successActions = successActionsCreator ? successActionsCreator(action.payload) : [];
    const failActions = failActionsCreator ? failActionsCreator(action.payload) : [];

    const { failed } = yield race({
      success: all(successActions.map(successAction => take(successAction))),
      failed: race(failActions.map(failAction => take(failAction))),
    });

    if (failed) {
      yield* handleFailure(action, globalPut);
    } else {
      yield call(globalPut.put, new GlobalActions().tarifiereShop(action));

      const { shopSuccess, shopFailed } = yield race({
        shopSuccess: take(GlobalActions.TARIFIERE_SHOP_SUCCESS),
        shopFailed: take(GlobalActions.TARIFIERE_SHOP_FAILED),
      });

      if (afterShopSuccess && shopSuccess) {
        yield call(afterShopSuccess);
      }

      if (afterShopError && shopFailed) {
        yield call(afterShopError);
      }
    }
  };
};
